import React from 'react';
import { node, string } from 'prop-types';

/** The heading + optional lead paragraph every section shares. */
const SectionHead = props => {
  const { id, heading, text } = props;
  return (
    <div className="section-head">
      <h2 id={id}>{heading}</h2>
      {text ? <p>{text}</p> : null}
    </div>
  );
};

SectionHead.propTypes = { id: string, heading: node.isRequired, text: string };

export default SectionHead;
